import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Chip, IconButton } from '@material-ui/core';
import { unescape } from 'lodash';
import CheckBoxOutlineBlankRoundedIcon from '@material-ui/icons/CheckBoxOutlineBlankRounded';
import CheckBoxRoundedIcon from '@material-ui/icons/CheckBoxRounded';
import {
  ProductPackageStatus,
  ProductPackageStatusText,
} from '../../data/common';
import PauseRoundedIcon from '@material-ui/icons/PauseRounded';
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
    backgroundColor: '#eee',
    fontSize: '0.9rem',
    fontWeight: '600',
    textAlign: 'left',
    width: '100%',
  },
  title: {
    fontSize: '1.2rem',
    margin: theme.spacing(0, 0, 1),
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'cneter',
  },
  desc: {
    color: '#888',
    fontSize: '0.8rem',
    ' & img': {
      maxWidth: '100%',
      objectFit: 'contain',
    },
  },
  status: {
    flexBasis: '120px',
    flexShrink: 0,
    textAlign: 'right',
  },
}));

const ProductPackageCard = (props) => {
  const { productPackage, select, cancel, selectedProductPackage } = props;
  const classes = useStyles();
  const [isSelected, setIsSelected] = useState(false);

  useEffect(() => {
    setIsSelected(
      selectedProductPackage && selectedProductPackage.id === productPackage.id,
    );
  }, [selectedProductPackage]);

  const handleClickSelect = () => {
    if (isSelected) {
      cancel();
    } else {
      select(productPackage);
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.title}>
        <div>{productPackage.name}</div>
        <div className={classes.status}>
          <Chip
            label={ProductPackageStatusText[productPackage.status]}
            color={
              productPackage.status === ProductPackageStatus.ONLINE
                ? 'default'
                : 'secondary'
            }
            icon={
              productPackage.status === ProductPackageStatus.ONLINE ? (
                <PlayArrowRoundedIcon />
              ) : (
                <PauseRoundedIcon />
              )
            }
            size="small"
            variant="outlined"
          />
          {select && cancel && (
            <IconButton color="primary" onClick={handleClickSelect}>
              {isSelected && <CheckBoxRoundedIcon />}
              {!isSelected && <CheckBoxOutlineBlankRoundedIcon />}
            </IconButton>
          )}
        </div>
      </div>
      <div className={classes.desc}>
        <div
          dangerouslySetInnerHTML={{
            __html: unescape(productPackage.description),
          }}
        />
      </div>
    </div>
  );
};

export default ProductPackageCard;
